<meta name="viewport" content="width=device-width, initial-scale=1.0">
</meta>
<template>
  <v-content>
    <div class="block latestPostBlock">
      <v-container>
        <v-row>
          <v-col v-for="item in items" :key="item.id" cols="12" md="6" sm="12">
            <div class="imgNews">
              <router-link style="color:white" :to="{ name: 'news-section', params: { id: item.id } }">
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-img class="white--text align-end styleNewsImg position-relative"
                    :src="item.images[0] ? '/repo/wot-lab/img/' + item.images[0] : '/repo/wot-lab/img/no_image.jpg'">
                      <v-overlay absolute :value="hover" color="rgba(30, 139, 195, 0.7)">
                        <img src="@/assets/click.png" alt="Click Icon" v-if="hover" class="hoverNews" />
                      </v-overlay>
                    </v-img>
                  </template>
                </v-hover>
              </router-link>
            </div>
            <div class="iconsNews">
              <div>
                <v-icon>mdi-calendar-month-outline</v-icon>
                <span class="stylrDate">{{ formatDate(item.fecha, item?.hora) }}</span>
              </div>
              <div>
                <v-icon>mdi-text-box-edit-outline</v-icon>
                <span class="stylrDate">{{ item.author }}</span>
              </div>
            </div>
            <h1 class="titleNews">{{ item.title }}</h1>
            <p class="announceNews">
              {{ item.announce }}
            </p>

          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-content>
</template>

<script>
//import newsAPI from "../services/newsAPI";
import newsData from "@/assets/json/news.json";

export default {
  name: "News",
  data() {
    return {
      items: []
    };
  },
  computed: {
    moreRedirect(id) {
      this.$router.push({ name: 'news', params: { id: id } });
      this.$router.go(0);
    }
  },
  created() {
    this.getNews();
  },
  methods: {
    /** 
    getNews() {
      newsAPI.get("/posts").then((response) => {
        this.items = response.data.sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          return dateB - dateA; 
        });
      });
    },
    */
    getNews() {
      this.items = newsData.sort((a, b) => {
        const dateA = this.parseDate(a.fecha, a.hora || "00:00");
        const dateB = this.parseDate(b.fecha, b.hora || "00:00");
        return dateB - dateA;
      });
    },
    parseDate(dateInput, timeInput = "00:00") {
      if (!dateInput || typeof dateInput !== 'string') return null;

      const dateRegex = /^(?:(\d{2})\/(\d{2})\/(\d{2,4})|(\d{2})-(\d{2})-(\d{2,4}))$/;
      const match = dateInput.match(dateRegex);
      if (!match) return null;

      let day, month, year;

      if (match[1] && match[2] && match[3]) {
        // dd/mm/yy o dd/mm/yyyy
        day = match[1];
        month = match[2];
        year = match[3];
      } else if (match[4] && match[5] && match[6]) {
        // mm/dd/yy o mm/dd/yyyy
        month = match[4];
        day = match[5];
        year = match[6];
      } else {
        return null;
      }

      // Convertir años de 2 dígitos a 4 dígitos (suponiendo 2000-2099)
      if (year.length === 2) {
        year = year < 50 ? `20${year}` : `19${year}`;
      }

      // Crear la fecha en formato ISO (yyyy-mm-dd)
      const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

      // Ahora agregamos la hora, si está definida
      const fullDate = `${isoDate}T${timeInput}:00`;

      // Retornar la fecha completa con la hora agregada
      return new Date(fullDate);
    },

    /**
     * Función para formatear la fecha y hora
     */
    formatDate(dateString, timeString) {
      const date = this.parseDate(dateString, timeString);
      if (!date || isNaN(date)) return "Invalid Date";
      const options = { 
        year: "numeric", 
        month: "2-digit", 
        day: "2-digit", 
        hour: "2-digit", 
        minute: "2-digit", 
        timeZone: "Europe/Paris" 
      };
      return new Intl.DateTimeFormat("en-GB", options).format(date);
    }
  },
};
</script>


<style>
.titleNews {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 0.5rem;
  color: #2E3038;
  text-transform: uppercase;
}

.announceNews {
  font-size: 1rem;
  color: #2E3038;
  line-height: 1;
  margin-bottom: 1.5rem;
}

@media screen and (min-width: 600px) {
  .imgNews {
    display: grid;
    position: relative;
    width: 100%;
    height: 300px;
  }

  .styleNewsImg {
    display: grid;
    position: absolute;
    width: 100%;
    /* Para que la imagen ocupe todo el ancho disponible */
    height: 100%;
    /* Para que la imagen ocupe todo el alto disponible */
    object-fit: cover;
  }

  .iconsNews {
    color: #FFFFFF;
    position: relative;
    size: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: #2E3038;
    padding: 0.5rem;
  }

  .icons {
    display: flex;
    justify-content: space-between;
    size: 1rem;
    background-color: #2E3038;
  }

  .hoverNews {
    width: 100px;
    height: 100px;
    mix-blend-mode: screen;
  }
}

@media screen and (max-width: 600px) {
  .imgNews {
    display: grid;
    position: relative;
    height: 300px;
    width: 100%;
  }

  .styleNewsImg {
    display: grid;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .iconsNews {
    size: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: #2E3038;
    padding: 1rem;
  }

  .icons {
    size: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: #2E3038;
  }

  .hoverNews {
    width: 100px;
    height: 100px;
    mix-blend-mode: screen;
  }
}
</style>